import { types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
import { AxiosResponse } from "axios";

const prefixUrl = "/client";

export default {
    async list(param: types.client.ReqClientList): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/list", param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async listForMy(param: types.client.ReqClientList): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/listForMy", param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async listForMain(): Promise<types.client.ResClientList> {
        const res = {} as types.client.ResClientList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/listForMain", null, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async detail(idx: number): Promise<types.client.ResClient> {
        const res = {} as types.client.ResClient;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/detail/" + idx, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async add(param: types.client.ReqClient): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/add", param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async addFile(idx: number, param: types.client.ReqFile): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post(prefixUrl + "/add/file/" + idx, formData, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async modify(idx: number, param: types.client.ReqClientForModify): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/modify/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async changeRealMember(idx: number, param: types.client.ReqClientForRealMember): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/modify/isReal/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async checkForTeamLeader(idx: number, state: number, comment?: string): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/confirm/" + idx + "/" + state, { comment }, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },
    async confirmMulti(state: number, param: { idxList: string; comment?: string }): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/confirm/" + state, param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async remove(idx: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/remove/" + idx, null, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async removeForFile(idx: number, idxFile: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/remove/" + idx + "/" + idxFile, null, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async exportExcel(param: types.client.ReqClientList): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post(prefixUrl + "/excel/download", param, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async exportExcelForCounselHistory(param: { startDate: string; endDate: string; dept: number }): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post(prefixUrl + "/counsel/history/excel/download", param, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async supportCard(idx: number, param: types.client.ReqClientSupportCard): Promise<types.client.ResClientSupportCard> {
        const res = {} as types.client.ResClientSupportCard;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/support/card/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async modifyForSupportCard(idx: number, param: types.client.ReqClientSupportCardForModify): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/support/card/modify/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async search(param: string): Promise<types.client.ResClientList> {
        const res = {} as types.client.ResClientList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/search/" + param, null, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async exportExcelForSupportCard(idx: number, param: types.client.ReqClientSupportCard): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post(prefixUrl + `/support/card/${idx}/excel/download`, param, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async exportPdfForSupportCard(idx: number, param: types.client.ReqClientSupportCard): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post(prefixUrl + `/support/card/${idx}/pdf/download`, param, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async listForHistory(idx: number, param: types.client.ReqClientHistoryList): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/history/list/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async detailForHistory(idx: number): Promise<types.client.ResClientHistory> {
        const res = {} as types.client.ResClientHistory;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/history/detail/" + idx, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async addForHistory(idx: number, targetIdx: number, param: types.client.ReqClientHistory): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/history/add/" + idx + "/" + targetIdx, param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async modifyForHistory(idx: number, targetIdx: number, param: types.client.ReqClientHistory): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/history/modify/" + idx + "/" + targetIdx, param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async removeForHistory(idx: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/history/remove/" + idx, null, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },
};
